import { idb } from "utils"
import { store } from "@redux"

import * as types from "../types/foodTaxesMap"
import { getAllTaxes } from "services"

export const fetchFoodTaxes = () => (
  async (dispatch) => {
    const branchId =
      store.getState().userAccountInfo.branchId

    try {
      const taxesFromDatabase =
        await idb.getAllItemsFromDatabase(
          branchId,
          "foodTaxes"
        )

      dispatch({
        type: types.ADD_FOOD_TAXES,
        taxes: taxesFromDatabase
      })

      const response = await getAllTaxes({ skip: 0, limit: 100 })

      dispatch({
        type: types.ADD_FOOD_TAXES,
        taxes: response
      })

      idb.saveItemsToDatabase(
        branchId,
        "foodTaxes",
        response
      )
    } catch (err) {
      console.log(err)
    }
  }
)

export const addFoodTaxes = (taxes) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "foodTaxes",
    taxes
  )

  return {
    type: types.ADD_FOOD_TAXES,
    taxes
  }
}

export const updateFoodTaxes = taxes => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.saveItemsToDatabase(
    branchId,
    "foodTaxes",
    taxes
  )

  return {
    type: types.UPDATE_FOOD_TAXES,
    taxes
  }
}

export const deleteFoodTaxes = (taxIds) => {
  const branchId =
    store.getState().userAccountInfo.branchId

  idb.deleteItemsFromDatabase(
    branchId,
    "foodTaxes",
    taxIds
  )

  return {
    type: types.DELETE_FOOD_TAXES,
    taxIds
  }
}

export const clearFoodTaxes = () => ({
  type: types.CLEAR_FOOD_TAXES
})